import { render, staticRenderFns } from "./SupplierManufacturingEmployee.vue?vue&type=template&id=faf64382&scoped=true&"
import script from "./SupplierManufacturingEmployee.vue?vue&type=script&lang=js&"
export * from "./SupplierManufacturingEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf64382",
  null
  
)

export default component.exports